import { useState, useEffect } from 'react';


const EVENTS = ['click', 'touchend'];

/**
 * Hook like Popper.js, but simpler (css are into caller)
 */

export default function useOverlay(referenceElement, popperElement) {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (!isOpen) return undefined;
        const handleClickOutside = ({ target }) => {
            if (!(popperElement === target || popperElement.contains(target))
                && !(referenceElement === target || referenceElement.contains(target))) {
                setIsOpen(false);
            }
        };
        EVENTS.forEach((e) => document.addEventListener(e, handleClickOutside));
        return () => EVENTS.forEach((e) => document.removeEventListener(e, handleClickOutside));
    }, [isOpen, setIsOpen, popperElement, referenceElement]);

    return [isOpen, setIsOpen];
}
